// extracted by mini-css-extract-plugin
export default {"main":"main--bb2i6","search":"search--S8n3o"};